import axios from "@/libs/axios";
// @ts-ignore
import i18n from "@/libs/i18n";
import { reactive, toRefs } from "@vue/composition-api";
import { BvModal } from "bootstrap-vue";
import ContactLabelInterface from "@/interfaces/contactLabel.interface";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/vue-query";

interface RootState {
    contactLabels: ContactLabelInterface[];
    loading: boolean;
    error: boolean;
}

const state: RootState = reactive({
    contactLabels: [],
    loading: false,
    error: false,
});

export default function useContactLabels(bvModal?: BvModal) {
    const tableColumns = [
        {
            key: "name",
            label: "Name",
            sortable: true,
        },
        {
            key: "color",
            label: "Color",
            sortable: true,
        },
        {
            key: "actions",
            label: "Actions",
        },
    ];
    const fetchContactLabels = (queryParams?: AxiosRequestConfig): void => {
        const { data, isLoading, isError } = useQuery(["contactLabels"], () => axios.get("/labels", queryParams), {
            select: (response: { data: ContactLabelInterface[] }) => response.data,
            refetchOnWindowFocus: false,
            staleTime: 60000,
            placeholderData: { data: [] } as any,
        });

        // @ts-ignore
        state.loading = isLoading;
        // @ts-ignore
        state.contactLabels = data;
        // @ts-ignore
        state.error = isError;
    };

    const createContactLabel = (contactLabel: ContactLabelInterface): Promise<ContactLabelInterface> => {
        return axios.post("/labels", contactLabel).then((response) => {
            state.contactLabels.push(response.data);
            return response.data;
        });
    };

    const updateContactLabel = (contactLabel: ContactLabelInterface): Promise<ContactLabelInterface> => {
        return axios.patch(`labels/${contactLabel.id}`, contactLabel).then((response) => {
            state.contactLabels.push(response.data);
            return response.data;
        });
    };

    const deleteContactLabel = (contactLabelId: number): Promise<unknown> => {
        if (!bvModal) {
            return Promise.resolve(false);
        }
        return bvModal
            .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                title: i18n.t("confirm.Are you sure?"),
                cancelTitle: i18n.t("confirm.Cancel"),
                cancelVariant: "light",
                okTitle: i18n.t("confirm.Yes, delete"),
                hideHeaderClose: false,
                headerCloseVariant: "light",
                centered: true,
            })
            .then((result): unknown => {
                if (result) {
                    return axios.delete(`/labels/${contactLabelId}`).then((response) => {
                        const deleteIndex = state.contactLabels.findIndex(
                            (contactLabel) => contactLabel.id === contactLabelId
                        );
                        state.contactLabels.splice(deleteIndex, 1);

                        return response.data;
                    });
                }
                return false;
            });
    };

    return {
        tableColumns,
        fetchContactLabels,
        createContactLabel,
        updateContactLabel,
        deleteContactLabel,
        ...toRefs(state),
    };
}
